import React, { createContext, useState, useContext } from 'react';

const PageTitleContext = createContext();

/**
 * 사용법
 * 1. 페이지 title 선언
 * import { usePageTitle } from '../../contexts/PageTitleContext'
 * 
 * 2. 상태관리
 * 컴포넌트 내부 {
 *   ....
 *   const { setPageTitle } = usePageTitle()
 * }
 * 
 * 3. useEffect 수정
 * useEffect(() => {
 *   setPageTitle('상세페이지')
 * }, [setPageTitle])
 * 
 * 
 * 
 * *****
 * 기본적으로 MO에서 로고가 뒤로가기로 변경되니 예외처리를 header.js에서 선언 필요
 * *****
 */
export const usePageTitle = () => useContext(PageTitleContext);

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};
